import React from 'react';
import { PEIImage, PEIRecordsInfo } from '@/common';
import styles from '@/styles/OfficesComponent.module.scss';
import { ZephrFeature } from '@/components/ZephrFeature';

export const OfficesComponent = ({
  institutionName,
  start,
  end,
  address,
}: {
  institutionName: string;
  address: string;
  start: number;
  end: number;
}) => {
  return (
    <section className={styles.container}>
      <h3 className={styles.heading}>Offices</h3>
      <ZephrFeature
        placeholder={
          <>
            <section className={styles['location-outer-container']}>
              <summary className={styles['location-container']}>
                <PEIImage src={'./marker.svg'} alt='' width={23} height={23.58} />
                <span className={styles.address}>100 Sample Street, City, 00000, Country</span>
              </summary>
            </section>
            <PEIRecordsInfo
              start={1}
              end={10}
              institutionName={institutionName}
              componentName='offices'
            />
          </>
        }
      >
        <section className={styles['location-outer-container']}>
          <summary className={styles['location-container']}>
            <PEIImage src={'./marker.svg'} alt='marker icon' width={23} height={23.58} />
            <span className={styles.address}>{address}</span>
          </summary>
        </section>
        <PEIRecordsInfo
          start={start}
          end={end}
          institutionName={institutionName}
          componentName='offices'
        />
      </ZephrFeature>
    </section>
  );
};
